import React, { useState } from "react"
import { Link } from "gatsby"
import Header from "./header"
import Footer from "./footer"

const Layout = props => {
  const [backdrop, setBackdrop] = useState(false)
  const toggleBackdrop = () => setBackdrop(!backdrop)
  return (
    <div className='container'>
      <div className='content'>
        <Header toggleBackdrop={toggleBackdrop} />
        {props.page !== "index" && (
          <div className='altBanner'>
            <div className='altBannerShade'></div>
            <div className='wrapper'>
              <div className='altBannerText'>
                <div>
                  <h1>{props.title ? props.title : props.page}</h1>
                  <span>{props.date}</span>
                </div>
                <div className='flex alignItemsCenter'>
                  <Link to='/'>Anasayfa</Link>
                  {props.page && props.pageLink ? (
                    <>
                      <div className='sitemapArrow'></div>
                      <Link to={props.pageLink}>{props.page}</Link>
                    </>
                  ) : (
                    props.page && (
                      <>
                        <div className='sitemapArrow'></div>
                        {props.page}
                      </>
                    )
                  )}
                  {props.title && <div className='sitemapArrow'></div>}
                  {props.title && props.title}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={`backdrop ${backdrop ? "backdropActive" : ""}`}></div>
        <main>{props.children}</main>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
